import { createFileRoute } from "@tanstack/react-router";
import { ComboImersoesContent, COMBO_FAQ } from "@/components/funis/ComboImersoesContent";

const CHECKOUT_URL_DEFAULT = "https://chk.eduzz.com/Q9N5Z2BP01?pf=1&df=1&utm_source=Funis";

export const Route = createFileRoute("/combo-imersoes")({
  head: () => ({
    meta: [
      { title: "Combo Imersões FEO por R$9,90 | Oferta exclusiva" },
      { name: "description", content: "07 Imersões da FEO pelo menor preço da história: R$9,90. Acesso a Coluna Lombar, MMII, Dor, Prescrição, Agentes Eletrofísicos, Fraturas e Terapia Manual." },
      { property: "og:title", content: "Combo Imersões FEO por R$9,90" },
      { property: "og:description", content: "07 Imersões da FEO por R$9,90. Menos de R$10 para mudar o nível do seu atendimento." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex,nofollow" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMBO_FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: () => <ComboImersoesContent defaultCheckoutUrl={CHECKOUT_URL_DEFAULT} />,
});
